/*
 * Collection ?q= enhancement. When a collection page has a ?q= param, replace the
 * product grid with AI-ranked results. Loaded only by the collection product-grid
 * section. Fail-soft: null/zero results leave the native collection grid intact.
 */
(function () {
  function reveal() { try { if (window.__aiSwapReveal) window.__aiSwapReveal(); } catch (e) {} }
  if (!window.AISearchClient || !window.AISearchClient.ready()) { reveal(); return; }
  const params = new URLSearchParams(window.location.search);
  const q = (params.get('q') || '').trim();
  if (q.length < 2) { reveal(); return; }

  const container = document.getElementById('ProductGridContainer');
  if (!container) { reveal(); return; }

  window.AISearchClient.query(q)
    .then((data) => {
      if (!data) { reveal(); return; }
      const total = (data.products || []).length + (data.articles || []).length;
      try { if (window.AISearchAnalytics) window.AISearchAnalytics.logSearch(q, total, 'collection'); } catch (e) {}
      if (total === 0) { reveal(); return; }
      container.innerHTML = window.AISearchClient.renderGrid(data, 'collection');
      reveal();
    })
    .catch(reveal);
})();
